import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Logo, SandboxStrip } from '@pryme/ui';
import { EnvironmentSwitch } from './EnvironmentSwitch';
import { userPortalUrl } from '../lib/portal';

/** Sticky site header: the sandbox band above a white top bar with the mark, the environment switch and account actions. */
export function DevHeader(props: { environment?: string; children?: ReactNode }) {
  return (
    <header className="p-header">
      <SandboxStrip environment={props.environment} />
      <div className="p-topbar">
        <Link to="/" aria-label="Pryme Developers home" style={{ display: 'inline-flex' }}>
          <Logo suffix="Developers" />
        </Link>
        <EnvironmentSwitch />
        <span className="p-spacer" />
        {props.children}
        <a href={userPortalUrl('/')} className="p-topbar-link p-hide-sm">
          Pryme portal <Icon name="external" size={14} />
        </a>
      </div>
    </header>
  );
}

/** Calm indicator of the signed-in developer's own identity (never a raw status code). */
export function SignedInAs(props: { status?: string }) {
  const s = props.status;
  const label = s === 'active' ? 'Verified identity' : s === 'active_sandbox' ? 'Test identity' : 'Identity not verified';
  const title =
    s === 'active'
      ? 'Signed in with your Pryme ID: verified in the production trust environment'
      : s === 'active_sandbox'
        ? 'Signed in with your Pryme ID: a sandbox test identity'
        : 'Your Pryme ID is not an active verified identity';
  return (
    <span className="p-topbar-user p-hide-sm" title={title}>
      <Icon name={s === 'active' ? 'shieldCheck' : 'user'} size={15} />
      {label}
    </span>
  );
}
